<template>
    <div class="row mt-3">
        <div class="col-12 d-flex justify-content-between align-items-center">
            <TitleComponent title="4. Confirmación de compra" subtitle="" />
            <Button :disabled="compra_finalizada" @click="volverPasoAnterior">volver al paso anterior</Button>
        </div>
        <div class="col-12" v-if="! loading">
            <ListadoAbonosComponent :abonos="datos_compradores" :datos_compra="datos_compra" :urls_imprimir="urls_imprimir" @setTotal="setTotal" />
            <PaymentCalculator :amountDue="total" v-if="total > 0 && (typeof(datos_compra.metodo_pago) == 'object' || datos_compra.metodo_pago.every(metodo => metodo.id == 1))" />
        </div>
        <b-col cols="12" v-if="teatro.activar_referidos && ! renovacion && teatro.hash != 'PSaG3BjUboDrGdZz6SQq'">
            <BuscarReferidoComponent
                @confirmado="aplicarReferido"
                :disabled="compra_finalizada"
            />
        </b-col>
        <b-col cols="12" v-if="teatro.activar_referidos && renovacion && datos_compradores[0].importe_monedero > 0">
            <SaldoMonederoComponent
                :saldo_disponible="datos_compradores[0].importe_monedero"
                :importe="calcularTotalAbono(datos_compradores[0])"
                :descuento_aplicado="datos_compradores[0].descuento_monedero === undefined ? 0 : parseFloat(datos_compradores[0].descuento_monedero)"
                @confirmado="descuentoConfirmado"
                @cancelar="cancelarDescuento"
                :disabled="compra_finalizada"
            />
        </b-col>
        <div class="col-12 mt-3" v-if="!compra_finalizada">
            <div class="row">
                <div class="col-12" v-if="!procesando && !error">
                    <Button class="btn-block" :disabled="procesando" @click.prevent="procesarCompra">FINALIZAR COMPRA</Button>
                </div>
                <div class="col-12" v-else>
                    <LoaderComponent />
                </div>
            </div>
        </div>
        <template v-if="compra_finalizada && !error">
            <div class="col-12 mt-3">
                <div class="alert alert-success" role="alert">
                    Compra finalizada <Button :href="url_factura + '&tid=' + configuracion.hash_teatro" target="blank_">IMPRIMIR RECIBO</Button>
                </div>
            </div>
            <div class="col-12 mt-2" v-for="(url, index) in urls_imprimir" :key="'btn-imprimir-' + index">
                <Button :href="url" target="blank_" v-if="url">IMPRIMIR ABONO {{ index + 1 }}</Button>
            </div>
            <div class="col-12 mt-1">
                <Button class="btn-block" @click.prevent="reiniciar">Volver</Button>
            </div>
        </template>
        <template v-if="error && loading == false">
            <div class="col-12 mt-3">
                <div class="alert alert-danger" role="alert">
                    {{ error }}
                </div>
            </div>
            <div class="col-12 mt-3">
                <Button class="btn-block" @click.prevent="reiniciar">Volver</Button>
            </div>
        </template>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import ListadoAbonosComponent from '@/components/backend/stepper/components/ListadoAbonosComponent';
    import BuscarReferidoComponent from '../components/BuscarReferidoComponent.vue';
    import SaldoMonederoComponent from '@/modules/front/abonos/SaldoMonedero.vue';
    import PaymentCalculator from '@/components/common/PaymentCalculator';

    export default {
        props: ['datos_compradores', 'datos_compra', 'procesando'],
        data() {
            return {
                compra_finalizada: false,
                loading: false,
                urls_imprimir: [],
                url_factura: [],
                referido_id: null,
                total: 0,
                error: null,
                local_datos_compradores: {...this.datos_compradores }
            }
        },
        methods: {
            procesarCompra() {
                this.$emit('procesar', this.referido_id);
            },
            reiniciar() {
                this.$emit('reiniciar');
            },
            aplicarReferido(abonado_id) {
                this.referido_id = abonado_id;
            },
            setTotal(total) {
                this.total = total;
            },
            descuentoConfirmado(descuento) {
                this.loading = true;
                this.local_datos_compradores[0].descuento_monedero = parseFloat(descuento);
                this.$emit('update:datos_compradores', this.local_datos_compradores);
                setTimeout(() => {
                    this.loading = false;
                }, 100)
            },
            cancelarDescuento() {
                this.loading = true;

                this.local_datos_compradores[0].descuento_monedero = 0;
                this.$emit('update:datos_compradores', this.local_datos_compradores);
                setTimeout(() => {
                    this.loading = false;
                }, 100)
            },
            volverPasoAnterior() {
                this.$emit('volver-paso-anterior');
            },
            calcularTotalAbono(abonado) {
                let total = 0;

                if(abonado.plazos) {
                    return abonado.plazos_pendientes[0].importe;
                } else {
                    const precio_total_taquilla = abonado.precio.precio;

                    if(abonado.descuento_integro) {
                        return precio_total_taquilla - abonado.descuento_integro;
                    } else if(abonado.descuento_aplicado){
                        const descuento = abonado.descuento_aplicado;
                        const cantidad_descuento = (descuento / 100) * precio_total_taquilla;
                        const total_con_descuento = precio_total_taquilla - cantidad_descuento;
                        return total_con_descuento;
                    }
                    
                    return precio_total_taquilla;
                }
            }
        },
        computed: {
            teatro(){
                return this.$store.getters.getTeatro
            },
            renovacion() {
                return this.$route.query.n_abonado_antiguo ? true : false;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        components: {
            TitleComponent, ListadoAbonosComponent, BuscarReferidoComponent, SaldoMonederoComponent, PaymentCalculator
        }
    }
</script>
